import {Swiper} from "swiper/bundle";

export default class RefSlider {
    constructor($slider) {
        const count = $slider.dataset.count;

        new Swiper(".mySwiper", {
            slidesPerView: 1,
            spaceBetween: 0,
            watchSlidesProgress: true,
            autoheight: false,
            loop: count > 1 ? true : false,
            navigation: {nextEl: ".ref__next", prevEl: ".ref__prev",},
        });
    }
}